import React from "react";

import { FormResources } from "../types/formData";
import { useValuationManagerContext } from "../ValuationManagerContext";

interface SubmittedPageProps {
  formResources: FormResources;
}

export const SubmittedPage = ({ formResources }: SubmittedPageProps) => {
  const { redirectUrl } = useValuationManagerContext();
  return (
    <div className="panel panel-default">
      <div className="panel-heading">{formResources.submitted.title}</div>
      {redirectUrl && (
        <div className="panel-body">
          <a href={redirectUrl} target="_blank" rel="noopener noreferrer">
            <button
              className="btn btn-success"
              data-testid="redirect-button"
              type="button"
            >
              Take me back to Carsanet
            </button>
          </a>
        </div>
      )}
    </div>
  );
};
